export default "__VITE_ASSET__rSIujDW0__"